module.exports = __webpack_public_path__ + "media/app/assets/races/dark_iron_dwarf_male-86dea713f6c65b644c70625b574e55b3.png";